var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.337h512V256H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 426.663c-.004.027 512-170.669 512-170.669L0 85.337v341.326z",
  fill: "#d80027"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M140.986 191.994c-29.718 0-53.895 24.176-53.895 53.895V266.1c0 29.718 24.178 53.895 53.895 53.895s53.895-24.176 53.895-53.895v-20.211c0-29.717-24.178-53.895-53.895-53.895zM174.67 266.1c0 15.054-9.927 27.831-23.579 32.134v-22.028l14.299-14.298-14.29-14.29-.008-5.087v-6.745h-20.211v20.211l-14.288 14.288 14.288 14.288v13.663c-13.651-4.303-23.579-17.08-23.579-32.134V245.89c0-18.573 15.111-33.684 33.684-33.684s33.684 15.111 33.684 33.684v20.21z",
  fill: "#ffda44"
})));

export default SvgEr;